import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

export const NavbarActionsSlotContext = createContext<HTMLDivElement | null>(null);
export const NavbarLeftActionsSlotContext = createContext<HTMLDivElement | null>(null);

interface NavbarPageActionsProps {
  readonly children: React.ReactNode;
}

/** Renders page controls into the global navbar’s right action slot. */
export function NavbarPageActions({ children }: NavbarPageActionsProps): React.ReactElement | null {
  const slot = useContext(NavbarActionsSlotContext);
  if (!slot) {
    return null;
  }
  return createPortal(children, slot);
}

/** Renders page controls into the global navbar’s left action slot (Bundle Work Orders). */
export function NavbarLeftPageActions({ children }: NavbarPageActionsProps): React.ReactElement | null {
  const slot = useContext(NavbarLeftActionsSlotContext);
  if (!slot) {
    return null;
  }
  return createPortal(children, slot);
}
